module.exports = __webpack_public_path__ + "img/Réalisation portail motorisée.6132fa60.jpg";